<style scoped>
/* https://github.com/vuetifyjs/vuetify/issues/4743 */
.toolbar-title {
  color: inherit;
  text-decoration: inherit;
}

.lang-menu-selected {
  font-weight: bolder;
  font-size: 18px;
}

.lang-menu-unselected {
  font-weight: normal;
  font-size: 16px;
}
</style>

<i18n>
{
  "en": {
    "login": "Login",
    "logout": "Logout",
    "back": "Back",
    "xrobotmon": "XRobotmon",
    "description": "XRobotmon mobile game bot as-a-service help manage your game 24x7 on the cloud. Line: Tsum Tsum bot / script to help auto send hearts, auto receive hearts and auto play. Cookie Run: Kingdom bot / script to help auto production, kingdom management and easily get to 1% in Golden Age of Trade.",
    "copySuccess": "XRobotmon ID has been copied. If you need any assistance, please provide this ID to the support team for quick account lookup. Thank you.",
    "copyError": "Error: Unable to automatically copy XRobotmon ID. Please copy it manually. If you need any assistance, please provide this ID to the support team for quick account lookup. Thank you.",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service"
  },
  "zhHant": {
    "login": "登入",
    "logout": "登出",
    "back": "關閉",
    "xrobotmon": "XRobotmon",
    "description": "XRobotmon雲端掛機免手機免電腦24/7全天幫你玩遊戲。Tsum Tsum 腳本/輔助/外掛/助手，自動送心、自動收心、自動玩。薑餅人王國腳本外掛，自動生產、大貿易時代輕鬆前1%",
    "copySuccess": "XRobotmon ID 已經自動複製好了，若需要任何協助，請貼上此ID給支援團隊，以便能快速查詢到您的帳號，謝謝。",
    "copyError": "錯誤：無法自動複製XRobotmon ID，請手動複製，若需要任何協助，請貼上此ID給支援團隊，以便能快速查詢到您的帳號，謝謝。",
    "privacyPolicy": "隱私權保護聲明",
    "termsOfService": "服務條款"
  },
  "ja": {
    "login": "ログイン",
    "logout": "ログアウト",
    "back": "戻る",
    "xrobotmon": "Xロボットモン",
    "description": "Xロボットモンはクラウド型(自分のスマホ/パソコンがいらない)のゲームロボットによる毎日24時間ゲーム連続稼働できる！ツムツムスクリプトハート自動送信、自動受信、自動プレイができて、クッキーラン：キングダムスクリプト自動生産、大交易時代1％以内でも大丈夫！",
    "copySuccess": "XRobotmon IDがコピーされました。サポートが必要な場合は、このIDをサポートチームに提供して、アカウント情報をすばやく検索できるようにしてください。ありがとうございます。",
    "copyError": "エラー：XRobotmon IDを自動的にコピーできませんでした。手動でコピーしてください。サポートが必要な場合は、このIDをサポートチームに提供して、アカウント情報をすばやく検索できるようにしてください。ありがとうございます。",
    "privacyPolicy": "プライバシー規約",
    "termsOfService": "利用規約"
  },
  "ko": {
    "login": "로그인",
    "logout": "로그아웃",
    "back": "이전페이지",
    "xrobotmon": "XRobotmon",
    "description": "XRobotmon는 24시간 클라우드 기반 자동으로 매크로 시스템입니다. 디즈니 티썸의 자동 플레이와 엑셀화로 된 기록을 통해 플레이에 도움됩니다. 쿠키런 킹덤의 자동 생산과 플레이를 통해 대무역 시대 이벤트에서 쉽게 상위1%에 도달할 수 있습니다.",
    "copySuccess": "XRobotmon ID가 복사되었습니다. 도움이 필요하시면 이 ID를 지원팀에 제공하여 계정 조회를 빠르게 할 수 있도록 도와드립니다. 감사합니다.",
    "copyError": "오류: XRobotmon ID를 자동으로 복사할 수 없습니다. 수동으로 복사하십시오. 도움이 필요하시면 이 ID를 지원팀에 제공하여 계정 조회를 빠르게 할 수 있도록 도와드립니다. 감사합니다.",
    "privacyPolicy": "개인 정보 정책",
    "termsOfService": "이용 약관"
  }
}
</i18n>

<template>
  <v-app>
    <v-toolbar flat color="primary" app dark>
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/" class="toolbar-title">
          <XRobotmonTitle />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-if="userProfile === null" flat to="/login">{{ $t('login') }}</v-btn>
      </v-toolbar-items>
      <v-bottom-sheet v-if="userProfile" v-model="sheet">
        <template v-slot:activator>
          <v-avatar :tile="false" :size="40" color="grey lighten-4">
            <img v-bind:src="userProfile.photoURL" width="40" height="40" />
          </v-avatar>
        </template>
        <v-card>
          <v-card-title class="justify-center">
            <v-avatar :tile="false" :size="80" color="grey lighten-4">
              <img v-bind:src="userProfile.photoURL" width="40" height="40" />
            </v-avatar>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-tile v-for="(provider, index) in userProfile.providerData" :key="index">
                <v-list-tile-avatar>
                  <v-icon x-large v-if="provider.providerId == 'google.com'"> mdi-google </v-icon>
                  <v-icon x-large v-if="provider.providerId == 'facebook.com'"> mdi-facebook </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ provider.displayName }} </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ provider.email }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-text>
            <v-list>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>XRobotmon ID</v-list-tile-sub-title>
                  <v-list-tile-title>{{ userProfile.uid }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon v-clipboard:copy="userProfile.uid" v-clipboard:success="onCopySuccess"
                    v-clipboard:error="onCopyError">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn @click="logOut" color="red" block outline>{{ $t('logout') }}</v-btn>
              </v-flex>
              <v-flex xs12 my-2>
                <v-btn @click="sheet = false" color="info" block>{{ $t('back') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>
      <v-btn icon @click="clickQA">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile v-for="(lang, idx) in languages" :key="idx" @click="changeLocale(lang.id, $event)">
            <v-list-tile-title v-if="language == lang.id" class="lang-menu-selected">{{
              lang.title
            }}</v-list-tile-title>

            <v-list-tile-title v-else class="lang-menu-unselected">{{ lang.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer class="pa-2 hidden-xs-only">
      <v-spacer></v-spacer>
      <div class="mr-2">
        <a href="/privacy-policy" target="_blank" class="grey--text text--darken-4">{{ $t('privacyPolicy') }}</a>
        <span class="mx-2">•</span>
        <a href="/terms-of-service" target="_blank" class="grey--text text--darken-4">{{ $t('termsOfService') }}</a>
      </div>
      <div>&trade; and &copy; 2019-{{ new Date().getFullYear() }}</div>
      &nbsp;
      <XRobotmonTitle />&nbsp;
      <div>All Rights Reserved.</div>
    </v-footer>
    <!-- for mobile device -->
    <v-footer class="pa-2 d-flex d-block hidden-sm-and-up" :style="'height: auto'">
      <div :style="'display: flex; justify-content: center'">
        <div>
          <a href="/privacy-policy" target="_blank" class="grey--text text--darken-4">{{ $t('privacyPolicy') }}</a>
          <span class="mx-2">•</span>
          <a href="/terms-of-service" target="_blank" class="grey--text text--darken-4">{{ $t('termsOfService') }}</a>
        </div>
      </div>
      <div :style="'display: flex; justify-content: center; align-items: center'">
        <p class="mb-0" :style="'text-align: center'">
          &trade; and &copy; 2019-{{ new Date().getFullYear() }} <span class="mx-2">
            <XRobotmonTitle />
          </span> All Rights
          Reserved.
        </p>
      </div>
    </v-footer>
    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card>
        <v-card-text>{{ dialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" text @click="dialog = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <Chatbot v-show="$route.name === 'intro' || $route.name === 'support'" /> -->
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import XRobotmonTitle from './components/XRobotmonTitle';
import Cookies from 'js-cookie';
// import Chatbot from './components/Chatbot';

export default {
  name: 'app',
  components: {
    XRobotmonTitle
    // Chatbot,
  },
  metaInfo() {
    return {
      title: this.$t('xrobotmon'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('description')
        }
      ]
    };
  },
  data: () => ({
    languages: [
      { title: 'English', id: 'en' },
      { title: '繁體中文', id: 'zhHant' },
      { title: '日本語', id: 'ja' },
      { title: '한국어', id: 'ko' }
    ],
    userProfile: null,
    sheet: false,
    dialog: false,
    dialogMessage: ''
  }),
  created() {
    const savedLang = Cookies.get('lang');
    if (savedLang !== undefined) {
      this.changeLocale(savedLang);
    }
    if (firebase.auth().currentUser) {
      this.$set(this, 'userProfile', firebase.auth().currentUser);
    }
    const forceLang = this.parseLangByURL();
    if (forceLang !== '') {
      this.$root.$i18n.locale = forceLang;
      this.$vuetify.lang.current = forceLang;
    }
  },
  computed: {
    language() {
      return this.$root.$i18n.locale;
    }
  },
  methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.getDefaultState();
          this.$router.push('/login');
        });
      window.FB.logout();
    },
    getDefaultState() {
      this.userProfile = null;
    },
    clickQA() {
      this.$router.push({ name: 'support' });
    },
    changeLocale(lang) {
      this.$root.$i18n.locale = lang;
      this.$vuetify.lang.current = lang;
      Cookies.set('lang', lang);
    },
    parseLangByURL() {
      if (location.search.indexOf('?') !== -1) {
        const pairs = location.search.substr(1).split('&');
        for (const pair of pairs) {
          const kv = pair.split('=');
          if (kv[0] === 'lang') {
            return kv[1] || '';
          }
        }
      }
      return '';
    },
    onCopySuccess() {
      this.dialogMessage = this.$t('copySuccess');
      this.dialog = true;
      this.sheet = false;
    },
    onCopyError() {
      this.dialogMessage = this.$t('copyError');
      this.dialog = true;
      this.sheet = false;
    }
  }
};
</script>
